import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSceneStore } from '../sceneStore'

function resolveAuthMode(urlMode) {
  if (urlMode === 'signup' || urlMode === 'sign_up') return 'signup'
  if (urlMode === 'verify') return 'verify'
  if (urlMode === 'forgot') return 'forgot'
  if (urlMode === 'reset') return 'reset'
  return 'login'
}

export function useSceneUrlSync() {
  const [searchParams, setSearchParams] = useSearchParams()
  const openPanel = useSceneStore((s) => s.openPanel)
  const closePanel = useSceneStore((s) => s.closePanel)

  const syncPanelToUrl = useCallback((nextPanel, mode) => {
    const next = new URLSearchParams(searchParams)
    if (nextPanel) {
      next.set('panel', nextPanel)
      if (mode) next.set('mode', mode)
    } else {
      next.delete('panel')
      next.delete('mode')
      next.delete('reset_token')
      next.delete('invite_token')
    }
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams])

  // URL → store on query changes only.
  // Do NOT depend on `panel`: a stale ?panel= must not reopen a dismissed panel.
  useEffect(() => {
    const urlPanel = searchParams.get('panel')
    const urlMode = searchParams.get('mode')
    const resetToken = searchParams.get('reset_token')
    const currentPanel = useSceneStore.getState().panel

    if (resetToken) {
      openPanel('auth', { mode: 'reset', payload: { resetToken } })
      return
    }

    if (urlPanel && urlPanel !== currentPanel) {
      openPanel(urlPanel, { mode: resolveAuthMode(urlMode) })
    }
  }, [searchParams, openPanel])

  return {
    syncPanelToUrl,
    closePanelAndUrl: () => {
      // Clear URL first so the panel cannot be reopened by a stale query.
      syncPanelToUrl(null)
      closePanel()
    },
  }
}
